var exports = {
  "S": "xaf9ae18d--e6a183--desktop-banner",
};

module.exports = exports;
